import { render, staticRenderFns } from "./DealProjectSummary.vue?vue&type=template&id=35c8101f&scoped=true"
import script from "./DealProjectSummary.vue?vue&type=script&lang=js"
export * from "./DealProjectSummary.vue?vue&type=script&lang=js"
import style0 from "./DealProjectSummary.vue?vue&type=style&index=0&id=35c8101f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8101f",
  null
  
)

export default component.exports